import type { CloneableConversationSettings } from '../Conversation';
import { defaultReasoningEffortForModel, Model, ReasoningEffort } from '../types';

import Flags from 'js/src/libs/flags';

export const SUBAGENT_TYPES = ['general', 'codeo', 'chart'] as const;
export type SubagentType = (typeof SUBAGENT_TYPES)[number];

export const DEFAULT_SUBAGENT_TYPE: SubagentType = 'general';

/**
 * The subagent kinds this user may start. `codeo` sits behind the codeo flag, since without it the
 * subagent gets no authoring tools, and `chart` behind the chart subagent flag.
 */
export function getAllowedSubagentTypes(): SubagentType[] {
    return SUBAGENT_TYPES.filter(
        (type) =>
            (type !== 'codeo' || Flags.canUseCodeo()) &&
            (type !== 'chart' || Flags.canUseChartSubagent()),
    );
}

export interface SubagentModelSettings {
    model: string;
    reasoningEffort: string;
}

/**
 * `general` is a clone, so it runs on whatever the parent is set to right now. `codeo` and `chart`
 * pin a model suited to their work, whatever the chat is set to.
 */
export function getSubagentModelSettings(
    type: SubagentType,
    parent: CloneableConversationSettings,
): SubagentModelSettings {
    switch (type) {
        case 'codeo':
            return { model: Model.DEEPSEEK_V4_1_FLASH, reasoningEffort: ReasoningEffort.MEDIUM };
        case 'chart':
            return { model: Model.CLAUDE_OPUS_5_5, reasoningEffort: ReasoningEffort.MEDIUM };
        case 'general':
            return {
                model: parent.model,
                reasoningEffort:
                    parent.reasoningEffort ??
                    defaultReasoningEffortForModel(parent.model) ??
                    ReasoningEffort.NONE,
            };
    }
}
